import { render, staticRenderFns } from "./AssetTypeImporter.vue?vue&type=template&id=01a3d794"
import script from "./AssetTypeImporter.vue?vue&type=script&lang=js"
export * from "./AssetTypeImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports